module.exports = __webpack_public_path__ + "media/images/ico-video-no-549cd24b.svg";